export const ApiEndpoints = {
  createProject: () => "/projects", //POST
  getAllProjects: () => "/projects", //GET
  getFolderDetails: (id: number) => `/projects/${id}`, //GET
  getDocumentsInFolder: () => `/folders/files`, //GET
  getPdfsInFolder: (folderName: string) => `/folders/${folderName}/pdfs`, //GET
  uploadFile: () => "/upload", //POST
  uploadMultiFile: () => "/upload", //POST
  uploadNewVersion: () => "/upload/file/version", //POST
  registerUpload: () => "/upload/register", //POST
  completeUpload: () => "/upload/complete", //POST
  cancelUpload: () => "/upload/cancel", //POST
  uploadStatuses: () => "/upload/status", //POST
  createTemplate: () => "/documents/copy",
  createTemplateVersion: () => "/documents/copy/version",
  getPrecedentFiles: () => "/documents/precedent", //GET
  getDocumentVersions: (rootDocumentId: number) => `/documents/${rootDocumentId}/versions`, //GET
  createNewVersion: (documentId: number) => `/documents/${documentId}/draft`, //POST
  search: () => "/search/documents", //GET
  searchFolders: () => "/search/projects", //GET
  searchVersions: (rootDocumentId: number) => `/search/document/${rootDocumentId}/versions`, //GET
  users: () => "/user", //GET
  grantUserPermission: () => "/permissions", //GET
  getVersionSharedAccess: () => "/permissions", //GET
  shareDocument: () => "/share", //POST
  shareSentDocument: () => "/file/share/grant", //POST
  userDetails: () => "/user", //GET
  getDocumentLinks: () => "/documents/links", //GET
  deleteDocument: (rootDocumentId: number) => `/documents/root/${rootDocumentId}`, //DELETE
  deleteVersion: (documentId: number) => `/documents/version/${documentId}`, //DELETE
  deleteProject: (projectId: number) => `/projects/${projectId}`, //DELETE
  grantPermissionFolder: () => `/permissions/folder/files`,
  getWorkingGroup: (projectId: number) => `/working-group/${projectId}`,
  getContacts: () => "/contact", //GET
  UpdateUserDetails: () => "/user", //PATCH
  UpdateFirstTimeLogin: () => "user/first-login", //PATCH,
  changeStatusOfProject: (projectId: number) => `/projects/${projectId}/status`, //PATCH,
  updateProjectDetails: () => "/projects/details", //PUT,
  getStatusesOfProject: () => "/projects/statuses", //GET
  projectInfo: (projectId: number) => `/projects/${projectId}/status`, //GET
  getProjectLimit:() => 'permissions', //GET
  downloadDocuments: () => '/documents/download',
  getProjectDocuments: (projectId: number) => `/documents/${projectId}/root`, //GET
  ongoingProcesses: () => "/notifications/ongoing-processes", //GET
  getOutlookMessageAttachments: (messageId: string) =>
    `/outlook/messages/${encodeURIComponent(messageId)}/attachments`, //GET
  getOutlookImports: () => "/outlook/imports", //GET
  createOutlookImports: () => "/outlook/imports", //POST
};
